<template>
  <div class="main">
    <div class="d-flex justify-space-between align-center">
      <div class="d-flex align-start">
        <div>{{ index }}. {{ question.title }}</div>
        <v-icon v-if="question.required" color="red" size="7" class="mr-4 mt-1">mdi-asterisk</v-icon>
      </div>
    </div>
    <div>
      <div class="answer">
        <div v-if="question.type === 'text'">
          <v-text-field placeholder="Văn bản câu trả lời" hide-details v-model="selected" />
        </div>
        <div v-if="question.type === 'single'">
          <v-radio-group class="ma-0 pa-0" hide-details v-model="selected">
            <v-radio v-for="answer in question.answers" :key="answer.id" :label="answer.title" :value="answer.id" />
          </v-radio-group>
        </div>
        <div v-if="question.type === 'multiple'">
          <v-checkbox
            v-for="answer in question.answers"
            :key="answer.id"
            class="mt-2"
            :label="answer.title"
            :value="answer.id"
            hide-details
            v-model="selected"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
export default {
  props: {
    question: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    },
    answers: {
      type: [String, Object, Array],
      default: ''
    }
  },
  data: () => ({ selected: null }),
  methods: {
    getData() {
      const question = this.question
      const res = { question: question.id }
      const val = this.selected
      if (question.type === 'text') res['answer'] = val
      else if (question.type === 'single') {
        const questionAnswer = question.answers.find(a => a.id === val)
        res['answer'] = { id: val, title: get(questionAnswer, 'title', '') }
      } else if (question.type === 'multiple') {
        let ids = val.filter(Boolean)
        const questionAnswers = question.answers
          .filter(a => ids.includes(a.id))
          .map(a => ({ id: a.id, title: a.title }))
        res['answers'] = questionAnswers
      }
      return res
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    }
  },
  watch: {
    answers: {
      handler(val) {
        if (val) {
          const type = get(this.question, 'type', '')
          if (type === 'text') this.selected = val || ''
          else if (type === 'single') this.selected = get(val, 'id', '')
          else if (type === 'multiple') this.selected = (val || []).map(v => get(v, 'id')).filter(Boolean)
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style>
.pointer {
  cursor: pointer;
}
.main {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
}
.answer {
  margin-top: 8px;
  min-width: 200px;
  max-width: 95%;
}
</style>
